var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"savings-graph"},[_c('div',{staticClass:"graph-circle"},[_c('div',{staticClass:"graph-circle__grey"}),_c('div',{staticClass:"graph-circle__active",style:({ transform: `rotate(${_vm.degrees}deg)` })}),_c('h3',[_c('small',[_vm._v("ca.")]),_vm._v(" "+_vm._s(_vm.value))])]),_c('p',[_vm._v(_vm._s(_vm.copy))])])
}
var staticRenderFns = []

export { render, staticRenderFns }